// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.c-button-til-solu {
  padding-top: 0px !important;
  position: relative;
  top: -10px !important;
}

.clear-option {
  text-align: center;
  /* Setur textann í miðju */
}

.clear-text {
  font-style: italic;
}

::ng-deep .mat-mdc-form-field.mbl-input {
  --mdc-outlined-text-field-outline-color: #a0a0a0 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input .mdc-notched-outline {
  border-color: #a0a0a0 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input.mat-focused {
  --mdc-outlined-text-field-focus-outline-color: #008800 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input.mat-focused .mdc-notched-outline {
  border-color: #008800 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input mat-label {
  color: rgba(0, 0, 0, 0.87) !important;
}

.mdc-list-item__primary-text {
  color: rgba(0, 0, 0, 0.87) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/properties-search/properties-search.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,2BAAA;EACA,kBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAMA;EACE,2DAAA;AAHF;AAKE;EACE,gCAAA;AAHJ;AAME;EACE,iEAAA;AAJJ;AAMI;EACE,gCAAA;AAJN;AAQE;EACE,qCAAA;AANJ;;AAUA;EACE,qCAAA;AAPF","sourcesContent":["@import \"../../../styles/variables.scss\";\r\n\r\n.c-button-til-solu {\r\n  padding-top: 0px !important;\r\n  position: relative;\r\n  top: -10px !important;\r\n}\r\n\r\n.clear-option {\r\n  text-align: center;\r\n  /* Setur textann í miðju */\r\n}\r\n\r\n.clear-text {\r\n  font-style: italic;\r\n}\r\n\r\n// -- MBL configs\r\n\r\n// Inputs colors\r\n::ng-deep .mat-mdc-form-field.mbl-input {\r\n  --mdc-outlined-text-field-outline-color: #a0a0a0 !important;\r\n\r\n  .mdc-notched-outline {\r\n    border-color: #a0a0a0 !important;\r\n  }\r\n\r\n  &.mat-focused {\r\n    --mdc-outlined-text-field-focus-outline-color: #008800 !important;\r\n\r\n    .mdc-notched-outline {\r\n      border-color: #008800 !important;\r\n    }\r\n  }\r\n\r\n  mat-label {\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n}\r\n\r\n.mdc-list-item__primary-text {\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
